module.exports = __webpack_public_path__ + "static/img/kv05.3649932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-2/kv05.jpg
// module id = 7aIv
// module chunks = 0